import { useEffect, useState } from 'react';
import { Wrench } from 'lucide-react';
import { api } from '@/lib/api';

/**
 * While OJP has the platform in maintenance, nobody can sign in or use the app: this covers every page with the notice
 * and checks every minute, so the app comes back by itself once maintenance is switched off.
 */
export function MaintenanceGate() {
  const [msg, setMsg] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    const check = () => api.get('/status').then((r) => { if (alive) setMsg(r.data?.data?.maintenance ? (r.data.data.message || 'We are doing some maintenance.') : null); }).catch(() => {});
    check();
    const t = window.setInterval(check, 60_000);
    const on = (e: Event) => setMsg((e as CustomEvent<string>).detail || 'We are doing some maintenance.');
    window.addEventListener('ojp:maintenance', on);
    return () => { alive = false; window.clearInterval(t); window.removeEventListener('ojp:maintenance', on); };
  }, []);
  if (!msg) return null;
  return (
    <div className="fixed inset-0 z-[1000] bg-[#0f172a] text-white flex items-center justify-center p-6" role="alertdialog" aria-live="assertive">
      <div className="max-w-md text-center">
        <div className="w-16 h-16 rounded-2xl bg-white/10 grid place-items-center mx-auto mb-5"><Wrench className="w-8 h-8 text-amber-300" /></div>
        <h1 className="text-2xl font-extrabold">We’ll be right back</h1>
        <p className="text-slate-300 mt-3 leading-relaxed">{msg}</p>
        <p className="text-xs text-slate-500 mt-6">This page reopens by itself when we are done.</p>
      </div>
    </div>
  );
}
